import { IFormat, IMerchandise } from '@/data/models/format';
import {
  formatGenre,
  getFormatDisplayName,
  getMerchandiseDisplayName,
} from '../components/common/ProductUtilities';

import { IOptions } from '../data/models/option';
import { IPackaging } from '../data/models/packaging';
import { BaseApiClient } from './BaseAPIClient';
import { IReleaseType } from '@/data/models/releaseType';
import { IGenre } from '@/data/models/genre';
import { FormatType } from '@/data/models/formatType';
import { ICurrency } from '@/data/models/currency';
import { ResponseModel } from '@/data/models/model';

//todo : API are pending for master data once done will integrate to backend
export class MasterAPIClient extends BaseApiClient {
  constructor() {
    super(BaseApiClient.findBaseUrl());
  }

  async getFormat(formatType?: FormatType): Promise<IOptions<IFormat>[]> {
    const path = `/prs/api/v1/formats?formatType=${formatType}`;
    const response: any = await this.get(path);
    let options: IOptions<IFormat>[] = [];
    if (response) {
      options = response.data.map((item: IFormat) => {
        return { value: item, label: getFormatDisplayName(item) };
      });
    }
    return options;
  }

  async getMerchandiseTypes(
    formatId?: number | null
  ): Promise<IOptions<IMerchandise>[]> {
    const path = formatId
      ? `/prs/api/v1/merchandise-types?formatId=${formatId}`
      : '/prs/api/v1/merchandise-types';
    const response: any = await this.get(path);
    let options: IOptions<IMerchandise>[] = [];
    if (response) {
      options = response.data.map((item: IMerchandise) => {
        return { value: item, label: getMerchandiseDisplayName(item) };
      });
    }
    return options;
  }

  async getPackaging(formatId: number | null): Promise<IOptions[]> {
    let path = '/prs/api/v1/packagings';
    if (formatId !== null) {
      path = `/prs/api/v1/packagings?formatId=${formatId}`;
    }
    const response: any = await this.get(path);
    let options: IOptions[] = [];
    if (response) {
      options = response.data.map((item: IPackaging) => {
        return { value: item.id, label: item.name };
      });
    }
    return options;
  }

  async getReleaseTypes(): Promise<IOptions[]> {
    const path = '/prs/api/v1/release-types';
    const response: any = await this.get(path);
    let options: IOptions[] = [];
    if (response) {
      options = response.data.map((item: IReleaseType) => {
        return { value: item.id, label: item.name };
      });
    }
    return options;
  }

  async getCurrencies(): Promise<IOptions[]> {
    const path = '/prs/api/v1/currencies';
    const response: any = await this.get(path);
    let options: IOptions[] = [];
    if (response) {
      options = response.data.map((item: ICurrency) => {
        return { value: item.id, label: item.name };
      });
    }
    return options;
  }

  async getGenres(value?: string): Promise<IOptions<IGenre>[]> {
    const path = '/prs/api/v1/genres';
    const response: ResponseModel<IGenre[]> = await this.get(path, { value });
    let result: IOptions<IGenre>[] = [];
    if (response) {
      result = response.data.map((item: IGenre) => {
        return { value: item, label: formatGenre(item) };
      });
    }
    return result;
  }

  async getIntegrationErrors(albumId: string): Promise<any[]> {
    const path = `/prs/api/v1/albums/${albumId}/integration-errors`;
    const response: any = await this.get(path);
    return response?.data || [];
  }
}

export const masterAPIClient = new MasterAPIClient();
